import React, { useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import { containerVariants, itemVariants } from '../data/animations';
import { motion, AnimatePresence } from 'framer-motion';
import { ProductsData } from '../data/products-data';
import Lightbox from 'yet-another-react-lightbox';
const UrunlerDetay = () => {
  const { id1, id2 } = useParams();

  const [openLightbox, setOpenLightbox] = useState(false);
  const [currentProductUrl, setCurrentProductUrl] = useState(null); // Store current product URL


  const productss = ProductsData.find(category => category.categoryUrl === id1);

  const products = productss.products.find(product => product.productUrl === id2)
  const handleImageClick = (productUrl) => {
    setCurrentProductUrl(productUrl); // Set the current product URL
    setOpenLightbox(true);
  };

  return (
    <div className='grid grid-cols-10'>

      <div className='col-start-2 col-span-8  text-4xl font-medium text-black mt-10 mb-16'>
        {products.productName}
      </div>



      <motion.div variants={containerVariants}
        initial="hidden"
        whileInView="show"
        exit="exit" className='col-start-2 col-span-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5'>


        {
          products.productImageData.map((item, index) => {
            return (
              <motion.div
                custom={index}
                key={index}

                variants={itemVariants}


              >

                <div
                  // onClick={ () => handleImageClick(item)}
                  className=''>

                  <div className="!overflow-hidden h-full group shadow-sm hover:shadow transition-all duration-300 hover:scale-105 bg-white">

                    <img
                      src={`/images/products/${id1}/${id2}/${item.image}.jpg`}
                      className="aspect-square h-full w-full object-cover cursor-pointer group-hover:scale-105 transition-all duration-300"

                      alt=""
                    />

                    {
                      item.name &&
                      <div className="px-5 pb-5 flex flex-col justify-between flex-1 space-y-5 pt-10 ">
                        <h6 className="font-medium text-2xl group-hover:text-turkuaz-blue transition-all duration-300">
                          {item.name}
                        </h6>

                        <div className={`h-8 w-full flex justify-end items-end`}>
                          <div className="h-7 w-7 relative flex justify-center items-center group-hover:rotate-45 transition-all duration-300">
                            <div className="absolute h-0.5 w-7 bg-[#B0B0B0]"></div>
                            <div className="absolute h-0.5 w-7 bg-[#B0B0B0] rotate-90"></div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>



                </div>

              </motion.div>
            );
          })
        }



      </motion.div>







      <>
        {currentProductUrl && (
          <Lightbox
            open={openLightbox}
            close={() => {
              setOpenLightbox(false);
              setCurrentProductUrl(null);
            }}
            slides={[
              {
                src: `/images/products/${id1}/${id2}/${currentProductUrl}.jpg`,
              },
            ]}
            imageFit="contain" // Example property to check in your library
            maxZoom={2}        // Example property to set maximum zoom
            className="custom-lightbox"

            zoom={{
              scrollToZoom: true,
              maxZoomPixelRatio: 5
            }}
          />

        )}
      </>
    </div>
  )
}

export default UrunlerDetay